import { FC, useEffect, useState } from "react";
import {
  stylesDemoTrading,
  stylesHeader,
  stylesHeaderSticky,
  stylesHeaderWrapper,
  stylesLiveTrading,
  stylesLogo,
  stylesText
} from "./styles";
import { HeaderProps } from "./types";
import Logo from "../assets/logo.svg?react";
import ArrowLeftIcon from "../assets/header/arrow-left-s-line.svg?react";
import Nav from "./Nav";
import { useDispatch, useStoreState } from "./store/useStore";
import User from "./User";
import { useTranslations } from "use-intl";
import ApplicationPopper from "./ApplicationPopper";
import LanguageIcon from "../assets/header/language.svg?react";
import MoonIcon from "../assets/header/moon.svg?react";
import SunIcon from "../assets/header/sun.svg?react";
import MenuIcon from "../assets/header/menu.svg?react";
import ActivityCryptonaryIcon from "../assets/header/Activity-Cryptonary.svg?react";
import LanguageDialog from "./LanguageDialog";
import useDemoTradingListen from "./hooks/useDemoTradingListen";
import useResponsiveHandlers from "./hooks/useResponsiveHandlers";
import { updateGlobalTheme } from "../common/CustomEvent";
import Cookies from "js-cookie";
import useKolActivityCheck from "./hooks/useKolActivityCheck";

const Header: FC<HeaderProps> = (props) => {
  const { customChildren, wrapperClass, customChangeLang } = props;

  const {
    theme,
    localeLink,
    isDemoTrading,
    showTheme,
    changeTheme,
    position = "sticky",
    isSticky,
    themeLock,
    hideAllMenus,
    baseUrl
  } = useStoreState();

  const [thmeMode, setThemeMode] = useState(theme);

  useResponsiveHandlers(position);

  const { toLiveTrading } = useDemoTradingListen();

  const { dispatch } = useDispatch();

  const t = useTranslations("header");

  const [open, setOpen] = useState(false);

  const { hasCompetence } = useKolActivityCheck(baseUrl);

  const onOpen = () => {
    setOpen(true);
  };

  const cancel = () => {
    setOpen(false);
  };

  const updateTheme = () => {
    if (showTheme && changeTheme) {
      changeTheme((theme) => {
        if (!themeLock) {
          dispatch({ type: "SET_THEME", payload: { theme: theme } });
        }
        updateGlobalTheme(theme);
        setThemeMode(theme);
      });
    }
  };

  useEffect(() => {
    setThemeMode(theme);
  }, [theme]);

  useEffect(() => {
    const isSwitching = Cookies.get("isSwitching");
    if (isSwitching) {
      Cookies.remove("isSwitching");
    }
  }, []);

  return (
    <div
      className={`${stylesHeaderWrapper()} ${
        position === "sticky"
          ? isSticky
            ? stylesHeaderSticky({ mode: theme })
            : ""
          : stylesHeader({ mode: theme })
      } ${position === "sticky" ? "sticky" : "relative"} ${wrapperClass}`}
    >
      {!customChildren ? (
        <>
          <div className="flex items-center">
            <a href={`${localeLink}/`}>
              <Logo
                className={`w-[107px] h-[28px] ${stylesLogo({
                  mode: theme
                })}`}
              />
            </a>
            {isDemoTrading && (
              <div className={stylesDemoTrading({ mode: theme })}>{t("demoTrading")}</div>
            )}
            {!hideAllMenus && <Nav />}
            {hasCompetence && (
              <div className="min-[1000px]:block cursor-pointer select-none max-[1000px]:hidden">
                <ActivityCryptonaryIcon
                  className="w-[120px] h-[42px] ml-[18px]"
                  onClick={() => {
                    window.location.href = `/activity${localeLink}/competition/d-cryptonary`;
                  }}
                />
              </div>
            )}
          </div>
          <div className={`flex items-center justify-end`}>
            {isDemoTrading && (
              <div className={stylesLiveTrading({ mode: theme })} onClick={toLiveTrading}>
                <ArrowLeftIcon className="w-[16px] h-[16px]" />
                <span className="ml-[8px]">{t("liveTrading")}</span>
              </div>
            )}
            <User />
            <div className="flex items-center max-[1000px]:hidden">
              <ApplicationPopper />
              <div className="h-[64px] flex items-center">
                <LanguageIcon
                  className={`w-[24px] h-[24px] ml-[24px] cursor-pointer ${stylesText({
                    mode: theme
                  })}`}
                  onClick={onOpen}
                />
              </div>
              <LanguageDialog open={open} cancel={cancel} customChangeLang={customChangeLang} />
              {showTheme && (
                <div
                  className="ml-[24px] h-[64px] flex items-center cursor-pointer"
                  onClick={updateTheme}
                >
                  {thmeMode === "light" ? (
                    <MoonIcon className={`${stylesText({ mode: theme })} w-[24px] h-[24px`} />
                  ) : (
                    <SunIcon className={`${stylesText({ mode: theme })} w-[24px] h-[24px`} />
                  )}
                </div>
              )}
            </div>
            {!hideAllMenus && (
              <div
                className="ml-[24px] min-[1000px]:hidden"
                onClick={() => {
                  dispatch({ type: "SET_DRAWEROPEN", payload: true });
                }}
              >
                <MenuIcon
                  className={`w-[24px] h-[24px] cursor-pointer ${stylesText({
                    mode: theme
                  })}`}
                />
              </div>
            )}
          </div>
        </>
      ) : (
        <>
          {customChildren}
          <div className="h-[64px] flex items-center">
            <LanguageIcon
              className={`w-[24px] h-[24px] ml-[24px] cursor-pointer ${stylesText({
                mode: theme
              })}`}
              onClick={onOpen}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default Header;
